<template>
  <div class="page-content">
    <card-container
      id="dashboard-customization-settings"
      :no-action="true"
    >
      <template #title>
        Your settings
      </template>

      <template #content>
        <div class="row align-items-center">
          <label class="col-sm-3 control-label">Registration call audio</label>
          <div class="col-sm-7">
            <dropdown-list
              v-model="controlledRegistrationCallAudio"
              :options="registrationCallAudioOptions"
            />
            <small
              v-if="showRefreshNote"
              class="text-danger d-block mt-1"
            >Reload page to finish sound update</small>
          </div>
        </div>
      </template>
    </card-container>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { meOperator } from '@/services/operators/viewModel';
import { updateOperator } from '@/services/operators/updateOperator';
import util from '@/Utils/util';
import { ListType } from '@/models/app';
import { RegCallAudioOption } from '@/gql/graphql';

const registrationCallAudioOptions: ListType[] = [
  { key: RegCallAudioOption.ChingChing, label: 'Ching-ching' },
  { key: RegCallAudioOption.GoodLuck, label: 'Good luck' },
];

const showRefreshNote = ref(false);

const controlledRegistrationCallAudio = computed({
  get: () => meOperator.value?.regCallAudio ?? '',
  set: async (newVal: RegCallAudioOption | '') => {
    const id = meOperator.value?.id;
    if (!id || !newVal || newVal === meOperator.value?.regCallAudio) return;
    showRefreshNote.value = true;
    if (meOperator.value) {
      meOperator.value = { ...meOperator.value, regCallAudio: newVal };
    }
    await updateOperator(id, { regCallAudio: newVal });
  },
});

onMounted(() => {
  util.moveToTop();
});
</script>
